import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from "recharts";

type BillingByPeriodProps = {
  data: {
    period: string;
    billing: number;
  }[];
  onSelectMonth: (month: string) => void;
};

const BillingByPeriod = ({data, onSelectMonth}: BillingByPeriodProps) => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="period" />
        <YAxis />
        <Tooltip />
        <Bar dataKey="billing" fill="#82CA9D" onClick={(entry) => onSelectMonth(entry.payload.period)} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BillingByPeriod;